import { ReactElement } from 'react';

import { Login } from '../components';

const LoginPage = (): ReactElement => {
    return <Login />;
};

export default LoginPage;
